import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./components/MainLayout";
import PublicLayout from "./components/PublicLayout";
import { publicRoutes, protectedRoutes, wrapProtectedRoute } from "./routes";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PublicLayout />}>{publicRoutes}</Route>
        <Route element={<MainLayout />}>
          {protectedRoutes.map((route) => {
            const wrappedRoute = wrapProtectedRoute(route);
            return (
              <Route
                key={wrappedRoute.path}
                path={wrappedRoute.path}
                element={wrappedRoute.element}
              />
            );
          })}
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
